module.exports = "<h2 class=\"text-center text-info\">Welcome to the Recipe Book</h2>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/home/home.component.html
// module id = ./src/app/core/home/home.component.html
// module chunks = main